var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#00B4F2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.088 3.646H3.526a2.932 2.932 0 0 0-2.93 2.93v20.33a2.932 2.932 0 0 0 2.93 2.93h14.376a2.932 2.932 0 0 0 2.931-2.93V10.391c0-.778-.31-1.524-.858-2.074L16.16 4.504a2.927 2.927 0 0 0-2.072-.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.953 26.786a2.932 2.932 0 0 0 2.931-2.931V7.342c0-.779-.31-1.524-.858-2.074L19.21 1.454A2.927 2.927 0 0 0 17.14.595H6.577a2.931 2.931 0 0 0-2.931 2.931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.542 4.39v3.342c0 .702.941 1.271 2.103 1.271h4.295M6.727 17.337l2.1 3.774c.556 1 1.83 1.054 2.452.102l4.91-7.523"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.8730a319.svg";
export { ForwardRef as ReactComponent };